// import goBootpayRequest from "components/bootpay"; // [DEPRECATED] PASS 본인인증 → Firebase 전화인증으로 대체
import PhoneAuthDialog from "components/phone_auth_dialog";
import ConfirmDialog from "components/confirm_dialog";
import OnlyConfirmDialog from "components/onlyConfirm_dialog";
import WithdrawDialog from "components/withdraw_dialog";
import ExpertCategoryDialog from "components/register/select_category";
import { login, updateUser, deleteAccount } from "firebase_/firebase_function/firebase_user";
import { REGION_OPTIONS, inferRegionFromAddress } from "util/constants/regions";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useUser } from "util/context/user_context";
import { formatDateTime } from "util/function/function";

const C = {
  ink: "#111827",
  body: "#374151",
  sub: "#6B7280",
  line: "#E5E7EB",
  greenDark: "#047857",
  greenBg: "#ECFDF5",
  greenBorder: "#A7F3D0",
  green: "#059669",
  bg: "#F7FAF7",
  amber800: "#92400E",
};

function SkeletonCard() {
  return (
    <div
      style={{
        background: "#fff",
        border: `1px solid ${C.line}`,
        borderRadius: 14,
        padding: 18,
        display: "flex",
        flexDirection: "column",
        gap: 10,
      }}
    >
      <div style={{ height: 14, width: "20%", background: "#F3F4F6", borderRadius: 6 }} />
      <div style={{ height: 42, width: "100%", background: "#F3F4F6", borderRadius: 8 }} />
    </div>
  );
}

function Field({ label, hint, children }) {
  return (
    <div
      style={{
        background: "#fff",
        border: `1px solid ${C.line}`,
        borderRadius: 14,
        padding: 18,
        display: "flex",
        flexDirection: "column",
        gap: 10,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span style={{ fontSize: 13, color: C.ink, fontWeight: 700, letterSpacing: "-0.01em" }}>
          {label}
        </span>
        {hint && <span style={{ fontSize: 11, color: C.sub }}>{hint}</span>}
      </div>
      {children}
    </div>
  );
}

const readOnlyBoxStyle = {
  flex: 1,
  height: 50,
  display: "flex",
  alignItems: "center",
  border: `1px solid ${C.line}`,
  background: C.bg,
  padding: "0 14px",
  borderRadius: 10,
  color: C.body,
  fontSize: 15,
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
};

const inputStyle = {
  width: "100%",
  height: 50,
  border: `1px solid ${C.line}`,
  background: "#fff",
  padding: "0 14px",
  borderRadius: 10,
  color: C.ink,
  fontSize: 15,
  outline: "none",
  fontFamily: "inherit",
  boxSizing: "border-box",
};

const subBtnStyle = {
  height: 50,
  padding: "0 18px",
  borderRadius: 10,
  border: `1px solid ${C.greenBorder}`,
  background: C.greenBg,
  color: C.greenDark,
  fontSize: 13,
  fontWeight: 700,
  cursor: "pointer",
  whiteSpace: "nowrap",
};

const MyPageScreen = ({ isMobile }) => {
  const { userData, setUserData } = useUser();
  const navigate = useNavigate();
  const [openCategory, setOpenCategory] = useState(false);
  const addressDetailRef = useRef(null);
  const materialRef = useRef(null);
  const [loading, setLoading] = useState(true);

  const [confirmModal, setConfirmModal] = useState(false);
  const [withdrawModal, setWithdrawModal] = useState(false);
  const [onlyConfirmDialog, setOnlyConfirmDialog] = useState(false);
  const [message, setMessage] = useState("");
  const [phoneAuthOpen, setPhoneAuthOpen] = useState(false); // Firebase 전화인증 모달

  useEffect(() => {
    const fetchUserData = async () => {
      const data = await login(userData.id);
      if (data && data[0]) setUserData(data[0]);
      setLoading(false);
    };
    fetchUserData();
  }, []);

  const handleAddressSearch = () => {
    try {
      const popup = window.open(
        "http://misnetwork.iptime.org:3989/api/get/kopo",
        "주소검색",
        "width=500,height=600",
      );

      const messageHandler = (event) => {
        try {
          const data =
            typeof event.data === "string" ? JSON.parse(event.data) : event.data;
          if (data.address) {
            if (popup && !popup.closed) {
              const inferred = inferRegionFromAddress(data.address);
              setUserData((prev) => ({
                ...prev,
                address: data.address,
                // 주소에서 광역시·도가 추출되면 region 자동 갱신, 안 되면 기존 값 유지
                region: inferred || prev.region,
              }));
              popup.close();
            }
          }
        } catch (error) {
          console.error("주소 데이터 파싱 오류:", error);
        }
      };

      window.addEventListener("message", messageHandler);

      const popupCheckInterval = setInterval(() => {
        if (popup.closed) {
          clearInterval(popupCheckInterval);
          window.removeEventListener("message", messageHandler);
        }
      }, 500);
    } catch (error) {
      console.error("주소검색 에러 : ", error);
    }
  };

  const handleDetailAddress = (e) => {
    setUserData((prev) => ({ ...prev, addressDetail: e.target.value }));
  };

  // [DEPRECATED] 부트페이(PASS) 인증 — Firebase 전화인증으로 대체
  // const handlePhoneChange = () => {
  //   goBootpayRequest((data) => {
  //     setUserData((prev) => ({ ...prev, phone: data.phone }));
  //   });
  // };

  const handlePhoneChange = () => {
    setPhoneAuthOpen(true);
  };

  /// Firebase 전화인증 성공 콜백 (인증된 전화번호로 갱신)
  const handlePhoneVerified = ({ phone }) => {
    setUserData((prev) => ({ ...prev, phone }));
  };

  const handleUserUpdate = async () => {
    if (!addressDetailRef.current?.value) {
      setMessage("상세주소를 입력해주세요.");
      setOnlyConfirmDialog(true);
      addressDetailRef.current?.focus();
      return;
    }
    if (userData.userType === "농가") {
      if (!materialRef.current?.value) {
        setMessage("주요 작물 / 축산을 입력해주세요.");
        setOnlyConfirmDialog(true);
        materialRef.current?.focus();
        return;
      }
    }
    const result = await updateUser(userData.docId, userData);
    setMessage(
      result ? "사용자 정보가 수정되었습니다." : "사용자 정보 수정에 실패했습니다.",
    );
    setOnlyConfirmDialog(true);
  };

  const handleMaterialChange = (e) => {
    setUserData((prev) => ({ ...prev, material: e.target.value }));
  };

  const handleExpertChange = (tag) => {
    setOpenCategory(false);
    setUserData((prev) => ({ ...prev, material: tag }));
  };

  const handleAffiliationChange = (e) => {
    setUserData((prev) => ({ ...prev, affiliation: e.target.value }));
  };

  const handleRegionChange = (e) => {
    setUserData((prev) => ({ ...prev, region: e.target.value }));
  };

  const handleWithdraw = async (reason) => {
    const ok = await deleteAccount(userData.docId, reason);
    if (ok) {
      sessionStorage.removeItem("userData");
      localStorage.removeItem("userData"); // 자동 로그인 해제
      window.location.replace("/"); // 뒤로가기 방지
    } else {
      setMessage("탈퇴 처리에 실패했습니다. 잠시 후 다시 시도해주세요.");
      setOnlyConfirmDialog(true);
    }
  };

  const formatPhone = (phone) =>
    phone ? phone.replace(/^(\d{3})(\d{3,4})(\d{4})$/, "$1-$2-$3") : "";

  const userInitial = (userData?.name || "?").charAt(0);
  const isExpert = userData?.userType === "수리기사";

  return (
    <div
      style={{
        fontFamily:
          'Pretendard, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, sans-serif',
        background: C.bg,
        minHeight: isMobile ? "100%" : "calc(100vh - 72px)",
      }}
    >
      <div
        style={{
          maxWidth: 760,
          margin: "0 auto",
          padding: isMobile ? "24px 16px 120px" : "32px 20px 80px",
          display: "flex",
          flexDirection: "column",
          gap: 20,
        }}
      >
        {/* Header */}
        <div>
          <div
            style={{
              fontSize: isMobile ? 22 : 26,
              fontWeight: 800,
              color: C.ink,
              letterSpacing: "-0.02em",
            }}
          >
            마이페이지
          </div>
          <div style={{ marginTop: 4, fontSize: 13, color: C.sub }}>
            계정 정보를 확인하고 수정할 수 있어요.
          </div>
        </div>

        {/* Profile hero */}
        <div
          style={{
            background: `linear-gradient(135deg, ${C.greenDark} 0%, #064E3B 100%)`,
            borderRadius: 18,
            padding: isMobile ? "20px" : "24px 28px",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            gap: 16,
            boxShadow: "0 8px 24px rgba(4,120,87,0.15)",
          }}
        >
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: 9999,
              background: "rgba(255,255,255,0.16)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 22,
              fontWeight: 800,
              flexShrink: 0,
            }}
          >
            {userInitial}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  fontSize: 18,
                  fontWeight: 800,
                  letterSpacing: "-0.01em",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {userData?.name || "—"}
              </div>
              {userData?.userType && (
                <span
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    background: "rgba(255,255,255,0.18)",
                    padding: "3px 10px",
                    borderRadius: 9999,
                  }}
                >
                  {userData.userType}
                </span>
              )}
            </div>
            <div style={{ marginTop: 4, fontSize: 12, color: "rgba(255,255,255,0.78)" }}>
              가입일 · {userData?.createDate ? formatDateTime(userData.createDate) : "—"}
            </div>
          </div>
        </div>

        {/* Fields */}
        {loading ? (
          <>
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </>
        ) : (
          <>
            {/* 휴대폰 번호 */}
            <Field label="휴대폰 번호">
              <div style={{ display: "flex", gap: 8 }}>
                <div style={readOnlyBoxStyle}>
                  {formatPhone(userData?.phone)}
                </div>
                <button type="button" onClick={handlePhoneChange} style={subBtnStyle}>
                  변경
                </button>
              </div>
            </Field>

            {/* 주소 */}
            <Field label="주소" hint="기본 주소 + 상세주소">
              <div style={{ display: "flex", gap: 8 }}>
                <div style={readOnlyBoxStyle}>{userData?.address || "주소 없음"}</div>
                <button type="button" onClick={handleAddressSearch} style={subBtnStyle}>
                  검색
                </button>
              </div>
              <input
                type="text"
                ref={addressDetailRef}
                defaultValue={userData?.addressDetail}
                onChange={handleDetailAddress}
                placeholder="상세주소를 입력해주세요"
                style={inputStyle}
              />
            </Field>

            {/* 내 지역 (광역시·도) */}
            <Field
              label="내 지역"
              hint={userData?.userType === "수리기사" ? "받은 요청 필터 기준" : "활동 지역"}
            >
              <select
                value={userData?.region || ""}
                onChange={handleRegionChange}
                style={{ ...inputStyle, cursor: "pointer" }}
              >
                <option value="">지역을 선택해주세요</option>
                {REGION_OPTIONS.map((r) => (
                  <option key={r} value={r}>
                    {r}
                  </option>
                ))}
              </select>
            </Field>

            {/* 알림 설정 진입 카드 */}
            <button
              type="button"
              onClick={() => navigate("/notifications/settings")}
              style={{
                background: "#fff",
                border: `1px solid ${C.line}`,
                borderRadius: 14,
                padding: "16px 18px",
                display: "flex",
                alignItems: "center",
                gap: 12,
                cursor: "pointer",
                textAlign: "left",
                width: "100%",
              }}
            >
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 9999,
                  background: C.greenBg,
                  color: C.greenDark,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 18,
                  flexShrink: 0,
                }}
                aria-hidden
              >
                🔔
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{ fontSize: 14, fontWeight: 800, color: C.ink, letterSpacing: "-0.01em" }}
                >
                  알림 설정
                </div>
                <div style={{ marginTop: 2, fontSize: 12, color: C.sub }}>
                  댓글·매칭 알림을 켜고 끌 수 있어요
                </div>
              </div>
              <span style={{ color: C.sub, fontSize: 18 }} aria-hidden>›</span>
            </button>

            {/* 전문분야 / 주요작물 */}
            {isExpert ? (
              <Field label="전문 분야" hint="작업 가능한 분야">
                <div style={{ display: "flex", gap: 8 }}>
                  <div style={readOnlyBoxStyle}>{userData?.material || "—"}</div>
                  <button
                    type="button"
                    onClick={() => setOpenCategory(true)}
                    style={subBtnStyle}
                  >
                    변경
                  </button>
                </div>
              </Field>
            ) : (
              <Field label="주요 작물 / 축산">
                <input
                  ref={materialRef}
                  defaultValue={userData?.material}
                  onChange={handleMaterialChange}
                  placeholder="주요 작물 또는 축산을 입력해주세요"
                  style={inputStyle}
                />
              </Field>
            )}

            {/* 소속 — 항상 표시, 선택사항 */}
            <Field label="소속" hint="선택 입력">
              <input
                defaultValue={userData?.affiliation}
                onChange={handleAffiliationChange}
                placeholder="소속을 입력해주세요 (예: ○○농기계센터)"
                style={inputStyle}
              />
            </Field>

            {/* 수정하기 (desktop) */}
            {!isMobile && (
              <button
                type="button"
                onClick={() => setConfirmModal(true)}
                style={{
                  marginTop: 4,
                  height: 52,
                  borderRadius: 12,
                  border: "none",
                  background: C.greenDark,
                  color: "#fff",
                  fontSize: 15,
                  fontWeight: 700,
                  cursor: "pointer",
                  letterSpacing: "-0.01em",
                }}
              >
                수정하기
              </button>
            )}

            {/* 탈퇴하기 (농가/수리기사 공통) */}
            <button
              type="button"
              onClick={() => setWithdrawModal(true)}
              style={{
                marginTop: isMobile ? 8 : 0,
                height: 44,
                borderRadius: 10,
                border: "none",
                background: "transparent",
                color: C.sub,
                fontSize: 13,
                fontWeight: 600,
                cursor: "pointer",
                textDecoration: "underline",
                textUnderlineOffset: 3,
              }}
            >
              회원 탈퇴
            </button>
          </>
        )}
      </div>

      {/* 모바일 sticky 하단 버튼 */}
      {isMobile && !loading && (
        <div
          style={{
            position: "sticky",
            bottom: 0,
            width: "100%",
            background: "#fff",
            padding: 16,
            borderTop: `1px solid ${C.line}`,
          }}
        >
          <button
            type="button"
            onClick={() => setConfirmModal(true)}
            style={{
              width: "100%",
              height: 52,
              borderRadius: 12,
              border: "none",
              background: C.greenDark,
              color: "#fff",
              fontSize: 15,
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            수정하기
          </button>
        </div>
      )}

      <ExpertCategoryDialog
        open={openCategory}
        setIsDialogOpen={setOpenCategory}
        onClose={(tag) => handleExpertChange(tag)}
      />
      <ConfirmDialog
        open={confirmModal}
        onClose={() => setConfirmModal(false)}
        onConfirm={() => {
          handleUserUpdate();
          setConfirmModal(false);
        }}
        message={"정보를 수정하시겠습니까?"}
      />
      <WithdrawDialog
        open={withdrawModal}
        isExpert={isExpert}
        onClose={() => setWithdrawModal(false)}
        onConfirm={(reason) => {
          setWithdrawModal(false);
          handleWithdraw(reason);
        }}
      />
      <OnlyConfirmDialog
        open={onlyConfirmDialog}
        onClose={() => setOnlyConfirmDialog(false)}
        message={message}
      />
      <PhoneAuthDialog
        open={phoneAuthOpen}
        onClose={() => setPhoneAuthOpen(false)}
        onSuccess={handlePhoneVerified}
      />
    </div>
  );
};

export default MyPageScreen;
